interface DangerouslySetInnerHTML {
  dangerouslySetInnerHTML: { __html: string };
}

interface Children {
  children: string;
}

const processText = (text: string): DangerouslySetInnerHTML | Children => {
  return /¤¤/g.test(text)
    ? {
        dangerouslySetInnerHTML: { __html: text.replace(/¤¤/g, '&shy;') }
      }
    : { children: text };
};

export default processText;
